import { render, staticRenderFns } from "./CardDinosaur.vue?vue&type=template&id=81880fe6&"
import script from "./CardDinosaur.vue?vue&type=script&lang=js&"
export * from "./CardDinosaur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports